(function () {
  'use strict';

  if (window.LuzioneAnalytics) return;

  var PREFIX = 'luzione:';
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'msclkid'];
  var SAFE_OPTION_NAMES = ['finish', 'material', 'fabric', 'color', 'colour', 'size', 'wood', 'stone', 'leather', 'orientation', 'configuration'];
  var FORM_EVENTS = {
    design_consultation: 'design_consultation_submit',
    project_request: 'project_request_submit',
    customization: 'customization_submit',
    trade_application: 'trade_application_submit',
    swatch_request: 'swatch_request_submit',
    general_lead: 'generate_lead'
  };

  function context() {
    return window.LuzioneAnalyticsContext || {};
  }

  function text(value, max) {
    if (value === undefined || value === null) return undefined;
    var result = String(value).trim().replace(/\s+/g, ' ');
    return result ? result.slice(0, max || 120) : undefined;
  }

  function number(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  }

  function id() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'lz_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
  }

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (_) {}
  }

  function captureAttribution() {
    var query = new URLSearchParams(window.location.search);
    var existing = {};
    try { existing = JSON.parse(storageGet('luzione_attribution') || '{}'); } catch (_) {}

    var foundCampaign = ATTR_KEYS.some(function (key) { return query.has(key); });
    if (foundCampaign) {
      var touch = { landing_page: window.location.pathname, captured_at: new Date().toISOString() };
      ATTR_KEYS.forEach(function (key) {
        if (query.has(key)) touch[key] = text(query.get(key), 250);
      });
      if (!existing.first_touch) existing.first_touch = touch;
      existing.last_touch = touch;
      storageSet('luzione_attribution', JSON.stringify(existing));
    }
    return existing;
  }

  function attribution() {
    try { return JSON.parse(storageGet('luzione_attribution') || '{}'); } catch (_) { return {}; }
  }

  function pageData() {
    var c = context();
    return {
      page_type: text(c.page_type, 50),
      page_title: text(document.title, 150),
      page_location: window.location.href.split('#')[0].slice(0, 500),
      page_path: window.location.pathname.slice(0, 250),
      product_id: text(c.product_id, 80),
      variant_id: text(c.variant_id, 80),
      product_name: text(c.product_name, 150),
      product_type: text(c.product_type, 100),
      product_vendor: text(c.product_vendor, 100),
      product_price: number(c.product_price),
      currency: text(c.currency || 'USD', 3)
    };
  }

  function compact(object) {
    var clean = {};
    Object.keys(object || {}).forEach(function (key) {
      var value = object[key];
      if (value !== undefined && value !== null && value !== '') clean[key] = value;
    });
    return clean;
  }

  function publish(name, data) {
    if (!name || !window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return false;
    var payload = compact(Object.assign({}, pageData(), data || {}, {
      event_id: (data && data.event_id) || id(),
      event_source: 'luzione_theme'
    }));
    Shopify.analytics.publish(PREFIX + name, payload);
    return true;
  }

  function closestRoom(element) {
    var room = element.closest('[data-luzione-room]');
    if (!room) return {};
    return {
      room_name: text(room.dataset.luzioneRoom, 120),
      room_value: number(room.dataset.luzioneRoomValue)
    };
  }

  function datasetEvent(element) {
    var eventName = element.dataset.luzioneEvent;
    if (!eventName) return;
    var payload = Object.assign({}, closestRoom(element), {
      section_name: text(element.dataset.luzioneSection, 80),
      form_location: text(element.dataset.luzioneFormLocation, 80),
      catalog_name: text(element.dataset.luzioneCatalogName, 120),
      product_name: text(element.dataset.luzioneProductName, 150)
    });
    if (element.href) payload.link_url = new URL(element.href, window.location.origin).pathname.slice(0, 250);
    publish(eventName, payload);
  }

  function contactEvent(anchor) {
    var href = anchor.getAttribute('href') || '';
    if (!/^(mailto:|tel:)/i.test(href)) return;
    publish('contact_click', {
      link_type: href.toLowerCase().indexOf('mailto:') === 0 ? 'email' : 'phone'
    });
  }

  function fillAttributionFields(form) {
    var a = attribution();
    var values = {};
    ATTR_KEYS.forEach(function (key) {
      values['first_' + key] = a.first_touch && a.first_touch[key];
      values['last_' + key] = a.last_touch && a.last_touch[key];
    });
    values.first_landing_page = a.first_touch && a.first_touch.landing_page;
    values.last_landing_page = a.last_touch && a.last_touch.landing_page;

    Object.keys(values).forEach(function (name) {
      if (!values[name]) return;
      var field = form.querySelector('[name="' + name + '"]');
      if (field) field.value = values[name];
    });
  }

  function safeFormData(form) {
    var budget = form.querySelector('[name="budget_band"], [name="budget_range"]');
    var leadType = form.querySelector('[name="lead_type"]');
    var projectType = form.querySelector('[name="project_type"]');
    var professional = form.querySelector('[name="designer_professional"], [name="is_professional"]');
    return {
      form_type: text(form.dataset.luzioneForm, 50),
      form_location: text(form.dataset.formLocation, 80),
      project_type: text((projectType && projectType.value) || form.dataset.projectType, 80),
      lead_type: text((leadType && leadType.value) || form.dataset.leadType, 50),
      budget_band: text(budget && budget.value, 50),
      trade_status: professional && professional.checked ? 'professional' : 'consumer'
    };
  }

  function formStart(form) {
    if (form.dataset.luzioneStarted === 'true') return;
    form.dataset.luzioneStarted = 'true';
    var type = form.dataset.luzioneForm;
    if (type === 'customization') publish('customization_start', safeFormData(form));
    if (type === 'design_consultation') publish('design_consultation_start', safeFormData(form));
  }

  function formSuccess(form, extra) {
    if (!form || form.dataset.luzioneSuccess === 'true') return false;
    var type = form.dataset.luzioneForm;
    var eventName = FORM_EVENTS[type];
    if (!eventName) return false;
    form.dataset.luzioneSuccess = 'true';
    return publish(eventName, Object.assign({}, safeFormData(form), {
      lead_id: text(extra && extra.leadId, 120)
    }));
  }

  function successMarker(marker) {
    var type = marker.dataset.luzioneFormSuccess;
    var eventName = FORM_EVENTS[type];
    var onceKey = 'luzione_success_' + type + '_' + window.location.pathname;
    if (!eventName || storageGet(onceKey)) return;
    storageSet(onceKey, '1');
    publish(eventName, {
      form_type: type,
      form_location: text(marker.dataset.formLocation, 80)
    });
  }

  function optionChange(input) {
    var optionName = text(input.dataset.luzioneConfigOption, 50);
    if (!optionName || SAFE_OPTION_NAMES.indexOf(optionName.toLowerCase()) === -1) return;
    var optionValue = input.type === 'radio' && !input.checked ? undefined : text(input.value, 100);
    if (!optionValue) return;
    publish('product_configuration', {
      option_name: optionName.toLowerCase(),
      option_value: optionValue
    });
  }

  function init() {
    captureAttribution();

    document.querySelectorAll('form[data-luzione-form]').forEach(fillAttributionFields);
    document.querySelectorAll('[data-luzione-form-success]').forEach(successMarker);
    document.querySelectorAll('[data-luzione-room]').forEach(function (room) {
      publish('room_view', closestRoom(room));
    });

    document.addEventListener('click', function (event) {
      var tracked = event.target.closest('[data-luzione-event]');
      if (tracked) datasetEvent(tracked);
      var room = event.target.closest('[data-luzione-room]');
      if (room && room.dataset.luzioneEngaged !== 'true') {
        room.dataset.luzioneEngaged = 'true';
        publish('room_engaged', closestRoom(room));
      }
      var anchor = event.target.closest('a[href]');
      if (anchor) contactEvent(anchor);
    }, { passive: true });

    document.addEventListener('toggle', function (event) {
      var details = event.target.closest('details[data-luzione-event]');
      if (details && details.open) datasetEvent(details);
    }, true);

    document.addEventListener('change', function (event) {
      var option = event.target.closest('[data-luzione-config-option]');
      if (option) optionChange(option);
    }, true);

    document.addEventListener('focusin', function (event) {
      var form = event.target.closest('form[data-luzione-form]');
      if (form) formStart(form);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[data-luzione-form]');
      if (!form) return;
      fillAttributionFields(form);
      // Submission is not success. Call LuzioneAnalytics.formSuccess only after
      // Formspree confirms the request or use a success marker on the redirect page.
    }, true);
  }

  window.LuzioneAnalytics = {
    publish: publish,
    formSuccess: formSuccess,
    fillAttributionFields: fillAttributionFields,
    getAttribution: attribution
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();